import { queryClient } from "App";
import { get } from "lodash";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getDataJobErrorsTableColumns } from "routes/data_tab/components/data_job_errors_table/DataJobErrorsTableColumnsAndFilters";
import { DATA_JOB_ERRORS_TABLE_CONSTANTS } from "routes/data_tab/components/data_job_errors_table/DataJobErrorsTableV3";
import UserService from "services/User";
import { addResizedColumns } from "./useTableConfig";

export const invalidateDataJobErrorsTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [DATA_JOB_ERRORS_TABLE_CONSTANTS.queryKey],
  });
};

export const useDataJobErrorsTable = ({ tableName = null }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getDataJobErrorsTableColumns();

    const dataJobErrorsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: dataJobErrorsTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableName, tableSettings, isTableSettingsFetched]);

  return { columns };
};
